import {gql} from '@apollo/client';

export default gql`
  mutation deleteCampaignNoise($input: DeleteCampaignNoiseInput!) {
    authed {
      success
    }
    deleteCampaignNoise(input: $input) {
      success
    }
  }
`;
